export const getKeys = <T extends object>(object: T): (keyof T)[] => {
  return (Object.keys(object) as unknown[]) as keyof object;
};
